import { Dispatch } from 'react'
import {
  getInactiveActiveCase,
  setActiveCase
} from 'reducers/activecase/activecaseSlice'
import {
  getEmptyAuthentication,
  setAuthentication
} from 'reducers/authentication/authenticationSlice'
import {
  getEmptyForgotPasswordData,
  setForgotPasswordData
} from 'reducers/forgotPassword/forgotpasswordSlice'
import {
  getEmptyUserProfile,
  setUserProfile
} from 'reducers/userprofile/userprofileSlice'
import { clearActiveCourse } from 'reducers/activecourse/activecourseSlice'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const logOut = (dispatch: Dispatch<any>): Promise<boolean> => {
  return new Promise((resolve) => {
    try {
      // clear out the redux store
      const authentication = getEmptyAuthentication()
      const userProfile = getEmptyUserProfile()
      const forgotPasswordData = getEmptyForgotPasswordData()
      const activeCase = getInactiveActiveCase()

      dispatch(setAuthentication(authentication))
      dispatch(setUserProfile(userProfile))
      dispatch(setForgotPasswordData(forgotPasswordData))
      dispatch(setActiveCase(activeCase))
      dispatch(clearActiveCourse())

      sessionStorage.clear()

      // Clear conversation IDs and chat messages from localStorage
      try {
        const keys = Object.keys(window.localStorage)
        keys.forEach((key) => {
          if (
            key.startsWith('conversationId_') ||
            key.startsWith('chatMessages_') ||
            key.startsWith('pillMessages_') ||
            key.startsWith('leftPanels_')
          ) {
            window.localStorage.removeItem(key)
          }
        })
      } catch (error) {
        // Silent fail - not critical
      }

      const cookies = document.cookie.split('; ')
      for (let c = 0; c < cookies.length; c++) {
        const d = window.location.hostname.split('.')
        while (d.length > 0) {
          const cookieBase =
            encodeURIComponent(cookies[c].split(';')[0].split('=')[0]) +
            '=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=' +
            d.join('.') +
            ' ;path='

          const p = location.pathname.split('/')
          document.cookie = cookieBase + '/'
          while (p.length > 0) {
            document.cookie = cookieBase + p.join('/')
            p.pop()
          }
          d.shift()
        }
      }
    } catch {
      resolve(false)
    }
    resolve(true)
  })
}
